import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {FormPageComponent} from './form-page/form-page.component';
import {RecapitulationComponent} from './recapitulation/recapitulation.component';
import {LoginPageComponent} from './login-page/login-page.component';
import {AdminPageComponent} from './admin-page/admin-page.component';
import {AuthGuard} from './shared/guards/Auth/auth.guard';
import {RacerTabComponent} from './racer-tab/racer-tab.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {RacesComponent} from './races/races.component';
import {SettingsComponent} from './settings/settings.component';
import {RoleGuard} from './shared/guards/Role/role.guard';
import {RacerDetailComponent} from './racer-detail/racer-detail.component';
import {FormBuilderComponent} from './form-builder/form-builder.component';
import {FormBuilderDetailComponent} from './form-builder-detail/form-builder-detail.component';
import {ShowFormComponent} from './show-form/show-form.component';
import {FormItemsComponent} from './form-items/form-items.component';
import {FormItemsDetailsComponent} from './form-items-details/form-items-details.component';
import {RaceDetailComponent} from './race-detail/race-detail.component';
import {SportTypeTabComponent} from './sport-type-tab/sport-type-tab.component';
import {SportTypeDetailComponent} from './sport-type-detail/sport-type-detail.component';
import {RaceDetailInfoComponent} from './race-detail-info/race-detail-info.component';
import {StartFeeComponent} from './start-fee/start-fee.component';
import {AllRacersComponent} from './all-racers/all-racers.component';
import {GoPaySettingComponent} from './go-pay-setting/go-pay-setting.component';
import {GoPaySettingDetailComponent} from './go-pay-setting-detail/go-pay-setting-detail.component';
import {RecapitulationFormComponent} from './recapitulation-form/recapitulation-form.component';
import {FioComponent} from './fio/fio.component';
import {FioDetailComponent} from './fio-detail/fio-detail.component';
import {RaceFioComponent} from './race-fio/race-fio.component';
import {AccountInfoComponent} from './account-info/account-info.component';
import {MailComponent} from './mail/mail.component';
import {RacerPayDetailComponent} from './racer-pay-detail/racer-pay-detail.component';
import {StartNumberComponent} from './start-number/start-number.component';
import {CashInfoComponent} from './cash-info/cash-info.component';
import {VoucherComponent} from './voucher/voucher.component';
import {VoucherDetailComponent} from './voucher-detail/voucher-detail.component';
import {GdprPageComponent} from "./gdpr-page/gdpr-page.component";

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'home', component: FormPageComponent },
  { path: 'showForm/:id', component: ShowFormComponent },
  { path: 'gdpr/:placeholder', component: GdprPageComponent },
  { path: 'recapForm', component: RecapitulationFormComponent },
  { path: 'recapitulation', component: RecapitulationComponent},
  { path: 'accountInfo', component: AccountInfoComponent },
  { path: 'cashInfo', component: CashInfoComponent },
  { path: 'login', component: LoginPageComponent},
  { path: 'admin', component: AdminPageComponent, canActivate: [AuthGuard], children: [
      { path: '', redirectTo: '/admin/dashboard', pathMatch: 'full'},
      { path: 'dashboard', component: DashboardComponent},
      { path: 'racers', component: RacerTabComponent},
      { path: 'racers/:id', component: RacerDetailComponent},
      { path: 'races', component: RacesComponent, canActivate: [RoleGuard], data: {
          expectedRoles: ['admin']
        }
      },
      { path: 'races', component: RaceDetailComponent, children: [
          // { path: '', redirectTo: '/admin/races/info', pathMatch: 'full' },
          { path: 'info/:id', component: RaceDetailInfoComponent },
          { path: 'startFee/:id', component: StartFeeComponent },
          { path: 'allRacers/:id', component: AllRacersComponent },
          { path: 'startNumber/:id', component: StartNumberComponent },
          { path: 'raceFio/:id', component: RaceFioComponent },
          { path: 'mailSetting/:id', component: MailComponent },
          { path: 'racerPay/:id', component: RacerPayDetailComponent },
          { path: 'racer/:id', component: RacerDetailComponent },
          { path: 'voucher/:id', component: VoucherComponent },
          { path: 'voucherDetail/:id', component: VoucherDetailComponent }
      ]},

      // { path: 'races/:id', component: RaceDetailComponent },
      { path: 'settings', component: SettingsComponent, children: [
          { path: '', redirectTo: '/admin/settings/forms', pathMatch: 'full' },
          { path: 'forms', component: FormBuilderComponent },
          { path: 'forms/:id', component: FormBuilderDetailComponent },
          { path: 'formItems', component: FormItemsComponent },
          { path: 'formItems/:id', component: FormItemsDetailsComponent },
          { path: 'sportType', component: SportTypeTabComponent },
          { path: 'sportType/:id', component: SportTypeDetailComponent },
          { path: 'users', component: FormBuilderComponent },
          { path: 'goPay', component: GoPaySettingComponent },
          { path: 'goPay/:id', component: GoPaySettingDetailComponent },
          { path: 'fio', component: FioComponent },
          { path: 'fio/:id', component: FioDetailComponent }
      ]}
    ]}
];


@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
